import { Color } from '@nect/ui/theme/color';
import { TextAlign } from '@nect/ui/theme/index';

import TextStyled from './text.styled';

export interface ITextProps {
    /**
    Text to be rendered
    */
    children: React.ReactNode;

    /**
    Color
    */
    color?: Color;
}

export type ITextParagraphProps = ITextProps & {
    /**
    Text align
    */
    align?: TextAlign;
};

export const TextButtonLarge = TextStyled.TextButtonLargeStyled;
export const TextButtonMedium = TextStyled.TextButtonMediumStyled;
export const TextButtonSmall = TextStyled.TextButtonSmallStyled;

export const TextBodyLargeParagraph = TextStyled.TextBodyLargePStyled;
export const TextBodyMediumParagraph = TextStyled.TextBodyMediumPStyled;
export const TextBodyRegularParagraph = TextStyled.TextBodyRegularPStyled;
export const TextBodySmallParagraph = TextStyled.TextBodySmallPStyled;
export const TextFootnoteMediumParagraph = TextStyled.TextFootnoteMediumPStyled;
export const TextFootnoteSmallParagraph = TextStyled.TextFootnoteSmallPStyled;
export const TextTinyRegularParagraph = TextStyled.TextTinyRegularPStyled;

export const TextBodyLargeSpan = TextStyled.TextBodyLargeSpanStyled;
export const TextBodyMediumSpan = TextStyled.TextBodyMediumSpanStyled;
export const TextBodyRegularSpan = TextStyled.TextBodyRegularSpanStyled;
export const TextBodySmallSpan = TextStyled.TextBodySmallSpanStyled;
export const TextFootnoteMediumSpan = TextStyled.TextFootnoteMediumSpanStyled;
export const TextFootnoteSmallSpan = TextStyled.TextFootnoteSmallSpanStyled;
export const TextTinyRegularSpan = TextStyled.TextTinyRegularSpanStyled;
